export const unSupportedStates = [
  'CT',
  'WV',
  'MA',
  'NH',
  'VT',
  'IA',
  'VI',
  'PR',
];
